import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useRef, useState } from "react";
import { toast } from "sonner";
import { endpoints } from "../../../hooks/endpoints";
import { getToken } from "../../../hooks/utils";

const ChangeTutorPassword = () => {
  const oldPassRef = useRef<HTMLInputElement>();
  const newPassRef = useRef<HTMLInputElement>();
  const [isPending, setIsPending] = useState(null);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    try {
      setIsPending(true);
      const res = await fetch(endpoints.changePassword, {
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        method: "POST",
        body: JSON.stringify({
          current_password: oldPassRef?.current?.value ?? "",
          new_password: newPassRef?.current?.value ?? "",
        }),
      });

      if (!res.ok) {
        throw Error("كلمة المرور الحالية غير صحيحة");
      }
      toast.success(<span className="text-green-700">تم تغيير كلمة المرور بنجاح</span>);
    } catch (e) {
      toast.error(<span className="text-red-600">{e.message}</span>);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <form
      onSubmit={handlePasswordChange}
      className="my-2 mb-4 rounded-lg p-4 bg-white border shadow-sm"
    >
      <h4 className="mb-4 pb-1 border-b-2 border-primary w-fit text-lg font-bold">
        تغيير كلمة السر
      </h4>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="flex flex-col">
          <label htmlFor="old-password" className="mb-1 font-medium">
            كلمة السر الحالية
          </label>
          <input
            ref={oldPassRef}
            id="old-password"
            type="password"
            placeholder="كلمة السر الحالية"
            className="border border-gray-300 rounded-lg px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-(--primary-color-light) focus:border-(--primary-color-light) peer"
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="new-password" className="mb-1 font-medium">
            كلمة السر الجديدة
          </label>
          <input
            ref={newPassRef}
            id="new-password"
            type="password"
            placeholder="كلمة السر الجديدة"
            className="border border-gray-300 rounded-lg px-3 py-2 appearance-none focus:outline-none focus:ring-2 focus:ring-(--primary-color-light) focus:border-(--primary-color-light) peer"
          />
        </div>
      </div>

      <Button className="bg-primary hover:bg-secondary text-white px-6 py-2 rounded-lg cursor-pointer w-full md:w-1/4">
        {isPending ? <Spinner variant="button" /> : "تغيير"}
      </Button>
    </form>
  );
};

export default ChangeTutorPassword;
